// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__CertNcamodule from "../grpc/CertNcamodule.js";
import * as Buhta_cabinet__DocumentEdo from "../grpc/DocumentEdo.js";
import * as Buhta_cabinet__NcalayerClientWrapper from "../util/bindings/NcalayerClientWrapper.js";
import * as Buhta_cabinet__Websocket from "../util/bindings/Websocket.js";
import * as Buhta_core__Let_syntax from "../../../../packages/core/lib/Let_syntax.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactUpdate from "../../../../vendored/reason-react-update/ReasonReactUpdate.js";

function initNcalayer(send) {
  return Buhta_cabinet__Websocket.make((function (ws) {
    const client = Buhta_cabinet__NcalayerClientWrapper.make(ws);
    Curry._1(send, {
      TAG: /* Ncalayer */ 1,
      _0: {
        TAG: /* Connected */ 0,
        _0: client
      }
    });
  }), (function (evt) {
    Curry._1(send, {
      TAG: /* Ncalayer */ 1,
      _0: {
        TAG: /* ConnectionFailed */ 1,
        _0: evt
      }
    });
  }), (function (evt) {
    Curry._1(send, {
      TAG: /* Ncalayer */ 1,
      _0: {
        TAG: /* Disconnected */ 2,
        _0: evt
      }
    });
  }), "wss://127.0.0.1:13579");
}

function selectCert(tin, client, send) {
  Curry._1(send, {
    TAG: /* SelectCert */ 2,
    _0: /* Pending */ 1
  });
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__CertNcamodule.NcamoduleClient.selectCert(client, Curry._2(Buhta_cabinet__CertNcamodule.RpcSelectSignCert.makeRequest, tin, undefined)), (function (result) {
    if (result.TAG !== /* Ok */ 0) {
      return Curry._1(send, {
        TAG: /* SelectCert */ 2,
        _0: {
          TAG: /* Failed */ 0,
          _0: result._0
        }
      });
    }
    const sign = result._0.cert;
    if (sign !== undefined) {
      return Curry._1(send, {
        TAG: /* SelectCert */ 2,
        _0: {
          TAG: /* Selected */ 1,
          _0: sign
        }
      });
    } else {
      return Curry._1(send, {
        TAG: /* SelectCert */ 2,
        _0: /* Initial */ 0
      });
    }
  }));
}

function rpcBulkSignDocument(cert, client, bulk, state, send) {
  const documents = Belt__Belt_List.map(bulk, (function (doc) {
    const match = doc.sign_document;
    let tmp;
    let exit = 0;
    if (typeof match === "string") {
      exit = 1;
    } else {
      const variant = match.NAME;
      if (variant === "Xml_document") {
        tmp = {
          NAME: "Xml",
          VAL: Curry._2(Buhta_cabinet__CertNcamodule.Signable.xml, match.VAL, undefined)
        };
      } else if (variant === "File_document") {
        const match$1 = match.VAL.file;
        if (match$1 !== undefined) {
          tmp = {
            NAME: "File",
            VAL: Curry._5(Buhta_cabinet__CertNcamodule.Signable.file, match$1.data, undefined, match$1.mime, undefined, undefined)
          };
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
    }
    if (exit === 1) {
      tmp = {
        NAME: "Xml",
        VAL: Curry._2(Buhta_cabinet__CertNcamodule.Signable.xml, "", undefined)
      };
    }
    return Curry._4(Buhta_cabinet__CertNcamodule.Signable.make, doc.id, Belt__Belt_List.map(doc.metadata, (function (param) {
      return Curry._3(Buhta_cabinet__CertNcamodule.Signable.metadata, param.name, param.value, undefined);
    })), tmp, undefined);
  }));
  const request = Buhta_cabinet__CertNcamodule.RpcBulkSignDocument.makeRequest(cert, documents, undefined, undefined);
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_cabinet__CertNcamodule.NcamoduleClient.bulkSign(client, request), (function (result) {
    if (result.TAG !== /* Ok */ 0) {
      return;
    }
    const signed = Belt__Belt_List.map(result._0.documents, (function (doc) {
      const match = doc.document;
      return Curry._4(Buhta_cabinet__DocumentEdo.DocumentSign.make, Belt__Belt_Option.getExn(doc.id), undefined, typeof match === "string" ? ({
          NAME: "Xml_document",
          VAL: ""
        }) : (
          match.NAME === "File" ? ({
              NAME: "File_document",
              VAL: {
                data: match.VAL.data,
                attached: false
              }
            }) : ({
              NAME: "Xml_document",
              VAL: match.VAL.data
            })
        ), undefined);
    }));
    Curry._1(send, {
      TAG: /* SubmitBulk */ 4,
      _0: signed
    });
  }));
}

function useForm(onStageTransitionOpt, onStartOver, onFetchNextBulk, onBulkSubmit, initialState) {
  const onStageTransition = onStageTransitionOpt !== undefined ? onStageTransitionOpt : (function (param) {
      
    });
  return ReasonReactUpdate.useReducerWithMapState(initialState, (function (action, state) {
    if (/* tag */ typeof action === "number" || typeof action === "string") {
      if (action === /* Start */ 0) {
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: Curry._1(initialState, undefined),
          _1: (function (param) {
            
          })
        };
      } else {
        return {
          TAG: /* SideEffects */ 2,
          _0: (function (param) {
            Curry._1(param.send, {
              TAG: /* FetchNextBulk */ 6,
              _0: param.state.register_num
            });
            Curry._1(onStageTransition, /* Processing */ 1);
          })
        };
      }
    }
    switch (action.TAG) {
      case /* TransitionTo */ 0 :
        const stage = action._0;
        return {
          TAG: /* SideEffects */ 2,
          _0: (function (param) {
            if (!/* tag */ (typeof stage === "number" || typeof stage === "string") && stage.TAG === /* SelectCert */ 1) {
              let tmp = stage._0;
              if (!/* tag */ (typeof tmp === "number" || typeof tmp === "string") && tmp.TAG === /* Selected */ 1) {
                Curry._1(param.send, /* StartProcessing */ 1);
              }
              
            }
            Curry._1(onStageTransition, stage);
          })
        };
      case /* Ncalayer */ 1 :
        const ncalayerStage = action._0;
        let client;
        client = /* tag */ typeof ncalayerStage === "number" || typeof ncalayerStage === "string" || ncalayerStage.TAG !== /* Connected */ 0 ? undefined : Caml_option.some(ncalayerStage._0);
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: {
            batch: state.batch,
            client: client,
            cert: state.cert,
            register_num: state.register_num,
            signed: state.signed,
            sign_failed: state.sign_failed,
            fetched: state.fetched
          },
          _1: (function (param) {
            Curry._1(param.send, {
              TAG: /* TransitionTo */ 0,
              _0: {
                TAG: /* Ncalayer */ 0,
                _0: ncalayerStage
              }
            });
          })
        };
      case /* SelectCert */ 2 :
        const selectCertStage = action._0;
        let cert;
        cert = /* tag */ typeof selectCertStage === "number" || typeof selectCertStage === "string" || selectCertStage.TAG !== /* Selected */ 1 ? undefined : selectCertStage._0.cert;
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: {
            batch: state.batch,
            client: state.client,
            cert: cert,
            register_num: state.register_num,
            signed: state.signed,
            sign_failed: state.sign_failed,
            fetched: state.fetched
          },
          _1: (function (param) {
            Curry._1(param.send, {
              TAG: /* TransitionTo */ 0,
              _0: {
                TAG: /* SelectCert */ 1,
                _0: selectCertStage
              }
            });
          })
        };
      case /* SignBulk */ 3 :
        const bulk = action._0;
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: {
            batch: state.batch,
            client: state.client,
            cert: state.cert,
            register_num: state.register_num,
            signed: state.signed,
            sign_failed: state.sign_failed,
            fetched: state.fetched + Belt__Belt_List.length(bulk) | 0
          },
          _1: (function (param) {
            const state = param.state;
            const client = state.client;
            if (client !== undefined) {
              const cert = state.cert;
              if (cert !== undefined) {
                rpcBulkSignDocument(cert, Caml_option.valFromOption(client), bulk, state, param.send);
              } else {
                console.log("WTF, this state should not be representable", state);
              }
            } else {
              console.log("WTF, this state should not be representable", state);
            }
          })
        };
      case /* SubmitBulk */ 4 :
        const bulk$1 = action._0;
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: state,
          _1: (function (param) {
            Curry._3(onBulkSubmit, param.send, bulk$1, undefined);
          })
        };
      case /* ProcessBulkResult */ 5 :
        const bulk$2 = action._0;
        const signed = Belt__Belt_List.reverse(Belt__Belt_List.keepMap(bulk$2, (function (result) {
          if (result.success) {
            return result.intent;
          }
          
        })));
        const register_num = signed ? signed.hd.register_num : state.register_num;
        const failed = Belt__Belt_List.keepMap(bulk$2, (function (result) {
          if (result.success) {
            return;
          } else {
            return result;
          }
        }));
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: {
            batch: state.batch,
            client: state.client,
            cert: state.cert,
            register_num: register_num,
            signed: Belt__Belt_List.size(signed) + state.signed | 0,
            sign_failed: Belt__Belt_List.concat(failed, state.sign_failed),
            fetched: state.fetched
          },
          _1: (function (param) {
            Curry._1(param.send, {
              TAG: /* FetchNextBulk */ 6,
              _0: param.state.register_num
            });
          })
        };
      case /* FetchNextBulk */ 6 :
        return {
          TAG: /* UpdateWithSideEffects */ 1,
          _0: state,
          _1: (function (param) {
            Curry._3(onFetchNextBulk, param.send, param.state, undefined);
          })
        };
    }
  }));
}

export {
  initNcalayer,
  selectCert,
  rpcBulkSignDocument,
  useForm,
}
/* Buhta_cabinet__CertNcamodule Not a pure module */
